import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import TerminalReceptionService from '_services/terminal-reception-service';

export const fetchTerminalReceptionReport = createAsyncThunk(
  'terminalReception/fetch',
  async (params, { signal }) => {
    return await TerminalReceptionService.getTerminalReceptionReport(params, signal);
  },
  {
    condition: (_params, { getState }) => {
      if (getState().terminalReception.status === 'loading') return false;
    },
  }
);

export const patchBooking = createAsyncThunk(
  'terminalReception/patchBooking',
  async ({ bookingId, patch }) => {
    await TerminalReceptionService.patchBooking(bookingId, patch);
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
  patchStatus: 'idle',
  patchError: null,
};

const terminalReceptionSlice = createSlice({
  name: 'terminalReception',
  initialState,
  reducers: {
    resetTerminalReception: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
    resetPatchBookingStatus: (state) => {
      state.patchStatus = 'idle';
      state.patchError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTerminalReceptionReport.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchTerminalReceptionReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchTerminalReceptionReport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(patchBooking.pending, (state) => {
        state.patchStatus = 'loading';
        state.patchError = null;
      })
      .addCase(patchBooking.fulfilled, (state) => {
        state.patchStatus = 'succeeded';
        state.patchError = null;
      })
      .addCase(patchBooking.rejected, (state, action) => {
        state.patchStatus = 'failed';
        state.patchError = action.error.message;
      });
  },
});

export const selectTerminalReceptionData = (state) => state.terminalReception.data;
export const selectTerminalReceptionStatus = (state) => state.terminalReception.status;
export const selectTerminalReceptionError = (state) => state.terminalReception.error;
export const selectPatchBookingStatus = (state) => state.terminalReception.patchStatus;
export const selectPatchBookingError = (state) => state.terminalReception.patchError;

export const { resetTerminalReception, resetPatchBookingStatus } = terminalReceptionSlice.actions;

export default terminalReceptionSlice.reducer;
